import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const CrownIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M3.5 17.5L2.5 7.5L7.5 11L12 4.5L16.5 11L21.5 7.5L20.5 17.5H3.5Z"
		/>

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M6.5 21H17.5" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M10 14H14" />
	</SvgIcon>
)

export default CrownIconAtom
